import MAINTAIN from "./bigDataColumns/MAINTAIN"
import AIR_INSUFFICIENCY from "./bigDataColumns/AIR_INSUFFICIENCY"
import AIR_FILTER_BLOCKED from "./bigDataColumns/AIR_FILTER_BLOCKED"
import HIGH_TEMPERATURE from "./bigDataColumns/HIGH_TEMPERATURE"
import INVERTER_HIGH_TEMPERATURE from "./bigDataColumns/INVERTER_HIGH_TEMPERATURE"
import LOW_FREQUENCY from "./bigDataColumns/LOW_FREQUENCY"
import OVERLOAD from "./bigDataColumns/OVERLOAD"
import OVER_CURRENT from "./bigDataColumns/OVER_CURRENT"
import LOW_APPLY_PRESSURE from "./bigDataColumns/LOW_APPLY_PRESSURE"
import EST_AIR_FILTER_BLOCKED from "./bigDataColumns/EST_AIR_FILTER_BLOCKED"
import EST_COOLING_WATER_BREAK from "./bigDataColumns/EST_COOLING_WATER_BREAK"
import EST_ELECTRONIC_FAN_OVERLOAD from "./bigDataColumns/EST_ELECTRONIC_FAN_OVERLOAD"
import EST_FAN_BOX_OVERLOAD from "./bigDataColumns/EST_FAN_BOX_OVERLOAD"
import EST_HIGH_TEMPERATURE from "./bigDataColumns/EST_HIGH_TEMPERATURE"
import EST_INVERTER_HIGH_TEMPERATURE from "./bigDataColumns/EST_INVERTER_HIGH_TEMPERATURE"
import EST_LOW_OIL_INLET_PRESSURE from "./bigDataColumns/EST_LOW_OIL_INLET_PRESSURE"
import EST_MOTOR_BEARING_HIGH_TEMPERATURE from "./bigDataColumns/EST_MOTOR_BEARING_HIGH_TEMPERATURE"
import EST_MOTOR_WINDING_HIGH_TEMPERATURE from "./bigDataColumns/EST_MOTOR_WINDING_HIGH_TEMPERATURE"
import EST_OIL_SEPARATOR_BLOCKED from "./bigDataColumns/EST_OIL_SEPARATOR_BLOCKED"
import EST_AIR_INLET_TEMPERATURE from "./bigDataColumns/EST_AIR_INLET_TEMPERATURE"
import ONE_YEAR_WITHOUT_MAINTAIN from "./bigDataColumns/ONE_YEAR_WITHOUT_MAINTAIN"
import START_FREQUENTLY from "./bigDataColumns/START_FREQUENTLY"
import LOAD_FREQUENTLY from "./bigDataColumns/LOAD_FREQUENTLY"
import OVER_PRESSURE from "./bigDataColumns/OVER_PRESSURE"
import MOTOR_HT from "./bigDataColumns/MOTOR_HT"
import OUT_ELECTRIC_TREND from "./bigDataColumns/OUT_ELECTRIC_TREND"

const warningTypes = [
  {
    type: "MAINTAIN",
    zh: "维保预警",
    en: "Maintain",
    id: 0,
    columns: MAINTAIN
  },
  {
    type: "AIR_INSUFFICIENCY",
    zh: "气量不足",
    en: "Air Insufficiency",
    id: 1,
    columns: AIR_INSUFFICIENCY
  },
  {
    type: "AIR_FILTER_BLOCKED",
    zh: "空滤堵塞",
    en: "Air Filter Blocked",
    id: 2,
    columns: AIR_FILTER_BLOCKED
  },
  {
    type: "HIGH_TEMPERATURE",
    zh: "高温预警",
    en: "High Temperature",
    id: 3,
    columns: HIGH_TEMPERATURE
  },
  {
    type: "INVERTER_HIGH_TEMPERATURE",
    zh: "变频器高温",
    en: "Inverter High Temperature",
    id: 4,
    columns: INVERTER_HIGH_TEMPERATURE
  },
  {
    type: "LOW_FREQUENCY",
    zh: "低温预警",
    en: "Low Frequency",
    id: 5,
    columns: LOW_FREQUENCY
  },
  {
    type: "OVERLOAD",
    zh: "空压机过载",
    en: "Overload",
    id: 6,
    columns: OVERLOAD
  },
  {
    type: "OVER_CURRENT",
    zh: "过流预警",
    en: "Over Current",
    id: 7,
    columns: OVER_CURRENT
  },
  {
    type: "LOW_APPLY_PRESSURE",
    zh: "应用压力低",
    en: "Low Apply Pressure",
    id: 8,
    columns: LOW_APPLY_PRESSURE
  },
  {
    type: "EST_AIR_FILTER_BLOCKED",
    zh: "空滤堵塞",
    en: "Est Air Filter Blocked",
    id: 9,
    columns: EST_AIR_FILTER_BLOCKED
  },
  {
    type: "EST_COOLING_WATER_BREAK",
    zh: "冷却水断开",
    en: "Est Cooling Water Break",
    id: 10,
    columns: EST_COOLING_WATER_BREAK
  },
  {
    type: "EST_ELECTRONIC_FAN_OVERLOAD",
    zh: "电控风机过载",
    en: "Est Electronic Fan Overload",
    id: 11,
    columns: EST_ELECTRONIC_FAN_OVERLOAD
  },
  {
    type: "EST_FAN_BOX_OVERLOAD",
    zh: "箱体风机过载",
    en: "Est Fan Box Overload",
    id: 12,
    columns: EST_FAN_BOX_OVERLOAD
  },
  {
    type: "EST_HIGH_TEMPERATURE",
    zh: "高温预警",
    en: "Est High Temperature",
    id: 13,
    columns: EST_HIGH_TEMPERATURE
  },
  {
    type: "EST_INVERTER_HIGH_TEMPERATURE",
    zh: "变频高温",
    en: "Est Inverter High Temperature",
    id: 14,
    columns: EST_INVERTER_HIGH_TEMPERATURE
  },
  {
    type: "EST_LOW_OIL_INLET_PRESSURE",
    zh: "进油压力低",
    en: "Est Low Oli Inlet Pressure",
    id: 15,
    columns: EST_LOW_OIL_INLET_PRESSURE
  },
  {
    type: "EST_MOTOR_BEARING_HIGH_TEMPERATURE",
    zh: "电机轴承高温",
    en: "Est Motor Bearing High Temperature",
    id: 16,
    columns: EST_MOTOR_BEARING_HIGH_TEMPERATURE
  },
  {
    type: "EST_MOTOR_WINDING_HIGH_TEMPERATURE",
    zh: "电机绕组高温",
    en: "Est Motor Winding High Temperature",
    id: 17,
    columns: EST_MOTOR_WINDING_HIGH_TEMPERATURE
  },
  {
    type: "EST_OIL_SEPARATOR_BLOCKED",
    zh: "油分堵塞",
    en: "Est Oil Separator Blocked",
    id: 18,
    columns: EST_OIL_SEPARATOR_BLOCKED
  },
  {
    type: "EST_AIR_INLET_TEMPERATURE",
    zh: "进气高温",
    en: "Est Air Inlet Temperature",
    id: 19,
    columns: EST_AIR_INLET_TEMPERATURE
  },
  {
    type: "ONE_YEAR_WITHOUT_MAINTAIN",
    zh: "一年未保养",
    en: "One Year without maintain",
    id: 20,
    columns: ONE_YEAR_WITHOUT_MAINTAIN
  },
  {
    type: "START_FREQUENTLY",
    zh: "频繁启停",
    en: "Start Frequently",
    id: 21,
    columns: START_FREQUENTLY
  },
  {
    type: "LOAD_FREQUENTLY",
    zh: "频繁加卸载",
    en: "Load Frequently",
    id: 22,
    columns: LOAD_FREQUENTLY
  },
  {
    type: "OVER_PRESSURE",
    zh: "超压运行",
    en: "Over Pressure",
    id: 23,
    columns: OVER_PRESSURE
  },
  {
    type: "MOTOR_HT",
    zh: "电机温升高",
    en: "Motor heat",
    id: 24,
    columns: MOTOR_HT
  },
  {
    type: "OUT_ELECTRIC_TREND",
    zh: "电流趋势预警",
    en: "Out Electric Trend",
    id: 25,
    columns: OUT_ELECTRIC_TREND
  }
]

export default warningTypes